<template>
  <div class="xs-12 m-8 l-9 myhome-profile-support">
    <h2 class="dea-heading--medium-xxl myhome-profile-support__title" tabindex="0">Assistenza</h2>
    <div class="dea-heading--regular-m">
      Nel nostro Portale di Assistenza troverai le risposte alle domande più frequenti.
    </div>
    <Buttons
      class="dea-button--small myhome-profile-support__faq-button"
      type="a"
      target="_blank"
      :href="`${$root.config.support_url}`"
      >Vai alle FAQ</Buttons
    >
    <div v-if="user.principal || user.teacher" class="myhome-support__agency">
      <Loader v-if="loading" />
      <template v-else-if="agencies.length">
        <h2 class="dea-heading--medium-xl">Le mie agenzie</h2>
        <!-- FIX: pass the right value to chips prop when it will be available -->
        <CardAgency
          v-for="(agency, index) in agencies"
          :key="index"
          :address="agency.address"
          :bottom-chips="true"
          :chips="agency.chips"
          details="#"
          :mail="email(agency.emails)"
          :name="agency.name"
          :phone="agency.phone_1"
          @open-modal="openExtendedCard(agency)"
        />
        <Modal
          v-if="Object.keys(selectedAgency).length"
          :visible="visible"
          :has-full-width="modalFullWidth"
          @modalClose="closeModal()"
        >
          <template #title>
            {{ selectedAgency.name }}
          </template>
          <template #content>
            <AgencyData
              :address="selectedAgency.address"
              :bottom-chips="true"
              :chips="selectedAgency.chips"
              :mail="email(selectedAgency.emails)"
              :name="selectedAgency.name"
              :phone="selectedAgency.phone_1"
            />
            <Buttons
              class="dea-button--large dea-button--iconRight myhome-profile-support__info-button"
              icon="richiedi-info"
              type="a"
              target="_blank"
              :href="`${$root.config.support_url}contatta-agenzia/${selectedAgency.id}/`"
              >Contatta l'agenzia</Buttons
            >
            <div class="myhome-profile-support__map-container">
              <AgencyMap
                v-if="visible"
                :marker="selectedAgency"
                :default-zoom="zoom"
                :default-center="center"
                :email="email(selectedAgency)"
                :max-zoom="5"
                :min-zoom="18"
              />
            </div>
          </template>
        </Modal>
      </template>
      <template v-else>
        <NoResults>
          <template #default>
            Per vedere i dettagli delle tue agenzie di riferimento, completa il tuo profilo, inserisci la scuola in cui
            insegni. Vai a
            <Links
              class="dea-links"
              :class="`dea-links--${user.targetCss.colorMod}`"
              label-class="dea-heading--regular-m"
              type="router-link"
              :to="{ name: 'my-profile-schools' }"
            >
              Il mio lavoro
            </Links>
          </template>
        </NoResults>
      </template>
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import AgencyData from "@/components/patterns/AgencyData";
import Buttons from "@/components/elements/Buttons";
import CardAgency from "@/components/patterns/CardAgency";
import Links from "@/components/elements/Links";
import Loader from "@/components/elements/Loader";
import Modal from "@/components/patterns/Modal";
import NoResults from "@/components/elements/NoResults";
import variables from "@/styles/variables.scss";
import handleWindowResize from "@/components/mixins/handleWindowResize";
import AgencyMap from "~/components/myProfile/views/AgencyMap";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileSupport",
  components: { AgencyData, AgencyMap, Buttons, CardAgency, Links, Loader, Modal, NoResults },
  mixins: [handleWindowResize],
  props: {
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      agencies: [],
      center: { lat: 0, lng: 0 },
      loading: true,
      maxZoom: 5,
      minZoom: 18,
      modalFullWidth: false,
      selectedAgency: {},
      visible: false,
      zoom: 16,
    };
  },
  mounted() {
    setFocus("myhome-profile-support__title");

    if (this.user.principal || this.user.teacher) {
      this.retrieveAgencies();
    }
  },
  activated() {
    setFocus("myhome-profile-support__title");
  },
  methods: {
    closeModal() {
      this.visible = false;
      document.body.style.overflowY = "auto";
    },
    email(emailsList) {
      let emailAdress = "";
      if (emailsList.length) emailAdress = emailsList[0].email;
      return emailAdress;
    },
    openExtendedCard(agency) {
      this.selectedAgency = agency;
      document.body.style.overflowY = "hidden";
      this.visible = true;
      this.modalFullWidth = this.getWindowWidth() <= variables.bpSizeSmall;
      this.center = { lat: agency.lat, lng: agency.lon };
    },
    retrieveAgencies() {
      fetch(`${this.$root.config.agenciesListUrl}?user_id=${this.user.id}`)
        .then(response => {
          this.loading = false;
          if (!response.ok) {
            throw new Error("Error");
          }
          return response.json();
        })
        .then(data => {
          this.agencies = data;
        })
        .catch(error => {
          Sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$button-width: 120px;
$info-button-width: 245px;
$map-width: 800px;
$map-height: 400px;
$map-width-tablet: 500px;

.myhome-profile-support {
  &__title {
    margin-top: 0;
  }

  .dea-button {
    margin: $space-small 0 $space-x-large;
  }

  &__faq-button {
    max-width: $button-width;
  }

  .dea-agency {
    margin-bottom: $space-base;
  }

  &__info-button.dea-button {
    margin-top: $space-large;
    max-width: $info-button-width;
  }

  .dea-modal-overlay {
    @include media("<=xs") {
      overflow-x: hidden;
      overflow-y: auto;
    }

    .dea-modal {
      @include media(">xs") {
        max-height: 90vh;
        overflow-y: auto;
      }
    }

    .dea-modal--full-width {
      @include media("<=xs") {
        bottom: 0;
        left: 0;
        overflow-y: auto;
        position: fixed;
        right: 0;
        top: 0;
        transform: none;
      }

      &__title-container,
      &__content {
        @include media("<=xs") {
          padding: 0;
        }
      }

      .dea-agency__chips-list__item {
        margin-right: $space-x-small;

        &:not(:first-child) {
          @include media("<=xs") {
            margin-top: $space-xx-small;
          }
        }
      }
    }
  }

  &__map-container {
    @include media("<=s") {
      width: $map-width-tablet;
    }

    @include media("<=xs") {
      width: 100%;
    }
    height: $map-height;
    width: $map-width;
  }
}
</style>
